import * as React from 'react';
import styled from 'styled-components';

import { DROP_SHADOW_VALUE } from './atoms/thumbnail';
import { SPACING } from '../../packages/constants';
import { StyledLoadingSpinner } from './atoms/thumbnail/thumbnail';
import { camelToKebab } from '../../../Scripts/Spotlight/Components/CamelToKebab';

export interface PreviewPageProps {
    id: string;
    content: string;
    title: string;
    pageType?: string;
    isLoading: boolean;
    isFixedSize: boolean;
    canBeFullscreen: boolean;
    isPortrait: boolean;
    maxWidth?: number;
    index: number;
}

interface PageProps {
    isFixedSize?: boolean;
    isPortrait?: boolean;
    pageLoading?: boolean;
    canBeFullscreen?: boolean;
    isSinglePage?: boolean;
    maxWidth?: number;
}

const PageItem = styled.li<PageProps>`
    background-color: #fff;
    box-shadow: ${DROP_SHADOW_VALUE};
    height: ${(props) => (props.pageLoading ? (props.isFixedSize ? '710px' : 'auto') : 'auto')};
    margin-bottom: ${(props) => (props.isSinglePage ? 'auto' : '20px')};
    max-width: ${(props) =>
        props.canBeFullscreen ? (props.isPortrait ? '51vw' : '71vw') : props.isPortrait ? '51vw' : undefined};
    min-height: ${(props) => (props.canBeFullscreen ? '48vw' : '710px')};
    min-width: 960px;
    margin-left: ${(props) => (props.canBeFullscreen || props.isPortrait ? 'auto' : undefined)};
    margin-right: ${(props) => (props.canBeFullscreen || props.isPortrait ? 'auto' : undefined)};
    width: ${(props) => (props.pageLoading ? '100%' : 'auto')};
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'unset')};
`;

const Page = styled.div<PageProps>`
    align-items: ${(props) => (props.pageLoading ? 'center' : 'flex-start')};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: ${(props) => (props.pageLoading ? (props.isFixedSize ? '710px' : '52vw') : 'auto')};
    justify-content: ${(props) => (props.pageLoading ? 'center' : 'flex-start')};
    min-height: 710px;
    padding: ${SPACING.MEDIUM};
    width: ${(props) => (props.pageLoading ? (props.isFixedSize ? '960px' : '100%') : 'auto')};
    overflow-x: ${(props) => (props.pageLoading ? undefined : 'auto')};
`;

export const PreviewPage = ({
    id,
    isFixedSize,
    canBeFullscreen,
    isLoading,
    isPortrait,
    maxWidth,
    title,
    index,
    pageType,
    content,
}: PreviewPageProps) => {
    return (
        <PageItem
            key={`page-${id}`}
            canBeFullscreen={canBeFullscreen}
            isFixedSize={isFixedSize}
            pageLoading={isLoading}
            isPortrait={isPortrait}
            maxWidth={maxWidth}
        >
            {isLoading ? (
                <Page
                    id={id}
                    data-test-id={`preview__page-${camelToKebab(title)}-${index}`}
                    isFixedSize={isFixedSize}
                    className={pageType ? `MoxySection__page-${pageType}` : ''}
                    pageLoading
                >
                    <StyledLoadingSpinner color={'black'} justify={'space-between'} />
                </Page>
            ) : (
                <Page
                    data-test-id={`preview__page-${camelToKebab(title)}-${index}`}
                    dangerouslySetInnerHTML={{ __html: content }}
                    id={id}
                    className={pageType ? `MoxySection__page-${pageType}` : ''}
                    isFixedSize={isFixedSize}
                />
            )}
        </PageItem>
    );
};
PreviewPage.displayName = 'PreviewPage';
